<template>
  <div class="detail" id="main">
    <a-card>
      <template #title>
        <div class="card-header">
          <span class="font20">{{ $route.query.tname }}</span>
          <a-button class="button floatR" type="primary" @click="html2pdf">
            保存至PDF
          </a-button>
        </div>
      </template>
    </a-card>
    <a-card class="box-card">
      <a-descriptions title="评估等级" :column="1">
        <a-descriptions-item label="评估等级">
          <template v-if="gradeSuccess && gradeResult && gradeResult.grade">
            {{ gradeResult.grade }}
          </template>
          <template v-else>/</template>
        </a-descriptions-item>
        <a-descriptions-item
          :label="`${gradeResult.grade}级别代表`"
          v-if="gradeSuccess && gradeResult && gradeResult.grade"
        >
          {{ gradeResult.gradeMessage }}
        </a-descriptions-item>
        <a-descriptions-item label=" ">
          <img
            style="margin-left: -50px"
            width="600"
            src="./imgs/img.png"
            alt=""
          />
        </a-descriptions-item>
      </a-descriptions>
      <a-descriptions title="建议授信额度" :column="1">
        <a-descriptions-item label="建议授信额度">
          <template v-if="gradeSuccess">{{ creditQuota }}万元</template>
          <template v-else>/</template>
        </a-descriptions-item>
        <a-descriptions-item v-if="gradeMessage" :label="gradeMessage" />
      </a-descriptions>
      <div class="analysis">
        <a-descriptions title="综合分析及风险提示" :column="1" bordered>
          <template v-if="gradeSuccess">
            <a-descriptions-item label="资产总额评价">
              {{ financeResult && financeResult.totalAssetsAssessment }}
            </a-descriptions-item>
            <a-descriptions-item label="负债总额评价">
              {{ financeResult && financeResult.totalLiabilitiesAssessment }}
            </a-descriptions-item>
            <a-descriptions-item label="营业总收入评价">
              {{ financeResult && financeResult.totalRevenueAssessment }}
            </a-descriptions-item>
            <a-descriptions-item label="净利润评价">
              {{ financeResult && financeResult.netProfitMarginAssessment }}
            </a-descriptions-item>
            <a-descriptions-item label="纳税总额评价">
              {{
                financeResult && financeResult.totalAmountOfTaxPaymentAssessment
              }}
            </a-descriptions-item>
            <a-descriptions-item label="资产负债率评价">
              {{ financeResult && financeResult.assetLiabilityRatioAssessment }}
            </a-descriptions-item>
            <a-descriptions-item label="净利润率评价">
              {{ financeResult && financeResult.netProfitMarginAssessment }}
            </a-descriptions-item>
            <a-descriptions-item label="资产净利润率评价">
              {{
                financeResult && financeResult.netProfitRateOfAssetsAssessment
              }}
            </a-descriptions-item>
            <a-descriptions-item label="总资产周转率评价">
              {{
                financeResult && financeResult.turnoverOfTotalAssetsAssessment
              }}
            </a-descriptions-item>
            <a-descriptions-item label="分析结论">
              {{ financeResult && financeResult.summary }}
            </a-descriptions-item>
          </template>
        </a-descriptions>
      </div>
      <div>
        <template v-if="gradeSuccess">
          <h1>司法数据</h1>
          <ul class="law-data" v-if="judicialResult">
            <li>
              <p>
                <img
                  src="./imgs/img1.png"
                  style="width: 100px; height: 100px"
                />
              </p>
              <dl>
                <dt>
                  <span style="color: #fed55f">
                    {{
                      judicialResult &&
                        judicialResult.judicialStatistics &&
                        judicialResult.judicialStatistics.bdze
                    }}
                  </span>
                  次
                </dt>
                <dd>列入被执行人名单次数</dd>
              </dl>
            </li>
            <li>
              <p>
                <img
                  src="./imgs/img2.png"
                  style="width: 100px; height: 100px"
                />
              </p>
              <dl>
                <dt>
                  <span style="color: #fea389">
                    {{
                      judicialResult &&
                        judicialResult.judicialStatistics &&
                        judicialResult.judicialStatistics.wlxrs
                    }}
                  </span>
                  次
                </dt>
                <dd>列入被执行人名单执行的总额</dd>
              </dl>
            </li>
            <li>
              <p>
                <img
                  src="./imgs/imgs3.png"
                  style="width: 100px; height: 100px"
                />
              </p>
              <dl>
                <dt>
                  <span style="color: #7ac39d">
                    {{
                      judicialResult &&
                        judicialResult.judicialStatistics &&
                        judicialResult.judicialStatistics.zxzs
                    }}
                  </span>
                  次
                </dt>
                <dd>列入失信被执行人名单次数</dd>
              </dl>
            </li>
          </ul>
          <div class="law-case" v-if="judicialResult">
            <div class="item">
              <p>涉案的案由所对应的案件个数</p>
              <a-table
                :dataSource="judicialResult.caseNumOfCauseAction"
                bordered
                :pagination="false"
                :columns="columns"
                style="width: 100%"
              ></a-table>
            </div>
            <div class="item">
              <p>案件地域分布</p>
              <a-table
                :dataSource="judicialResult.lawCaseDistribution"
                :columns="ajcolumns"
                :pagination="false"
                bordered
                style="width: 100%"
              ></a-table>
            </div>
          </div>
          <h1>失信数据</h1>
          <div>
            <p class="title">主体失信</p>
            <table-view
              :showPage="false"
              :pagination="false"
              :columns="_headersMain"
              rowKey="id"
              :data="loseConfienceMainData"
            ></table-view>
            <p class="title">担保失信</p>
            <table-view
              :showPage="false"
              :pagination="false"
              :columns="_headersGuarantee"
              rowKey="id"
              :data="loseConfienceGuaranteeData"
            ></table-view>
            <p class="title">关联失信</p>
            <table-view
              :showPage="false"
              :pagination="false"
              :columns="_headersRelated"
              rowKey="id"
              :data="loseConfienceRelatedData"
            ></table-view>
          </div>
        </template>
        <div v-if="warnMessage">
          <h2 style="margin-top: 35px">风险提示</h2>
          <p class="title indent2">
            {{ warnMessage }}
          </p>
        </div>

        <p class="title indent2" v-if="!gradeSuccess">
          出现失信或资不抵债或系统黑名单（根据具体情况展示原因），
          <span style="color: #ff6010">不建议您对该企业进行评估授信。</span>
        </p>
        <div class="back">
          <a-button class="button" type="primary" @click="handleBack">
            返回
          </a-button>
        </div>
      </div>
    </a-card>
  </div>
</template>

<script>
import { TableView } from 'lxfintech-fe'
import { getSassTableData } from '../api'
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
export default {
  data() {
    const ajcolumns = [
      {
        title: '企业名称',
        width: '180',
        dataIndex: 'companyname',
      },
      {
        title: '区域',
        width: '180',
        dataIndex: 'geo',
      },
      {
        width: '180',
        title: '案件个数',
        dataIndex: 'dqzs',
      },
    ]
    const columns = [
      {
        title: '企业名称',
        width: '180',
        dataIndex: 'company',
      },
      {
        title: '案由',
        width: '180',
        dataIndex: 'causename',
      },
      {
        width: '180',
        title: '案件个数',
        dataIndex: 'ayzs',
      },
    ]
    //这里存放数据
    return {
      loseConfienceMainData: [],
      columns,
      ajcolumns,
      headersMain: [],
      loseConfienceGuaranteeData: [],
      headersGuarantee: [],
      loseConfienceRelatedData: [],
      headersRelated: [],
      financeResult: {},
      count: 1,
      initHeader: [],
      initResultData: [],
      gradeResult: {},
      gradeSuccess: true,
      creditList: [],
      creditQuota: '',
      judicialResult: {},
      gradeMessage: '',
      warnMessage: '',
    }
  },
  components: { TableView },
  computed: {
    _headersGuarantee() {
      const _res = [{ title: '', dataIndex: '__name' }]
      this.headersMain.forEach(item => {
        _res.push({
          title: `${item.label}`,
          dataIndex: `${item.prop}`,
        })
      })
      return _res
    },
    _headersRelated() {
      const _res = [{ title: '', dataIndex: '__name' }]
      this.headersMain.forEach(item => {
        _res.push({
          title: `${item.label}`,
          dataIndex: `${item.prop}`,
        })
      })
      return _res
    },
    _headersMain() {
      const _res = [{ title: '', dataIndex: '__name' }]
      this.headersMain.forEach(item => {
        _res.push({
          title: `${item.label}`,
          dataIndex: `${item.prop}`,
        })
      })
      return _res
    },
  },
  //方法集合
  methods: {
    handleBack() {
      this.$router.go(-1)
    },
    html2pdf() {
      html2Canvas(document.querySelector('#main'), {
        allowTaint: true,
        taintTest: false,
        useCORS: true,
        async: true,
        scale: '2',
        dpi: '192',
      }).then(canvas => {
        const contentWidth = canvas.width
        const contentHeight = canvas.height
        // 一页pdf显示html页面生成的canvas高度;
        const pageHeight = Math.ceil((contentWidth / 595.28) * 841.89)
        // 未生成pdf的html页面高度
        let leftHeight = contentHeight
        // pdf页面偏移
        let position = 0
        // a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
        const imgWidth = 595.28
        const imgHeight = (595.28 / contentWidth) * contentHeight
        // console.log(canvas)
        const pageData = canvas.toDataURL('image/jpeg/png', 1)
        const PDF = new JsPDF('', 'pt', 'a4', true)
        // console.log(PDF)
        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
            leftHeight -= pageHeight
            position -= 841.89
            if (leftHeight > 0) {
              PDF.addPage()
            }
          }
        }
        PDF.save(this.$route.query.tname + '信用报告.pdf') //保存PDF
        return PDF.output('datauristring')
      })
    },
    //担保失信
    initGuaranteeData() {
      if (this.creditResult && this.creditResult.guaranteeDiscredit) {
        let { guaranteeDiscreditList } = this.creditResult.guaranteeDiscredit
        let tableData = []
        let guaranteeDiscreditListArr = Array.from(guaranteeDiscreditList)
        tableData = [{}]
        let headers = [
          {
            prop: 'title',
            label: '期限',
          },
        ]
        for (let i = 0; i < guaranteeDiscreditListArr.length; i++) {
          {
            headers.push({
              label: `${guaranteeDiscreditListArr[i].startDate}~${guaranteeDiscreditListArr[i].endDate}`,
              prop:
                'key' +
                guaranteeDiscreditListArr[i].startDate.split('.')[0] +
                guaranteeDiscreditListArr[i].startDate.split('.')[2],
            })
          }
          {
            let item1 = guaranteeDiscreditListArr[i]
            let { amountOfMoney, numberOfTimes } = item1
            tableData[0].title = '对外担保'
            tableData[0][
              'key' +
                item1.startDate.split('.')[0] +
                item1.startDate.split('.')[2]
            ] = `${amountOfMoney ? amountOfMoney : '--'}/${
              numberOfTimes ? numberOfTimes : '--'
            }`
          }
        }
        this.loseConfienceGuaranteeData = Array.from(tableData)
        this.headersGuarantee = headers
      }
    },
    //关联失信
    initRelatedData() {
      if (this.creditResult && this.creditResult.relationDiscredit) {
        let { relationDiscreditList } = this.creditResult.relationDiscredit
        let tableData = []
        let relationDiscreditListArr = Array.from(relationDiscreditList)
        tableData = [{}]
        let headers = [
          {
            prop: 'title',
            label: '期限',
          },
        ]
        for (let i = 0; i < relationDiscreditListArr.length; i++) {
          {
            headers.push({
              label: `${relationDiscreditListArr[i].startDate}~${relationDiscreditListArr[i].endDate}`,
              prop:
                'key' +
                relationDiscreditListArr[i].startDate.split('.')[0] +
                relationDiscreditListArr[i].startDate.split('.')[2],
            })
          }
          {
            let item1 = relationDiscreditListArr[i]
            let { amountOfMoney, numberOfTimes } = item1
            tableData[0].title = '关联企业债务'
            tableData[0][
              'key' +
                item1.startDate.split('.')[0] +
                item1.startDate.split('.')[2]
            ] = `${amountOfMoney ? amountOfMoney : '--'}/${
              numberOfTimes ? numberOfTimes : '--'
            }`
          }
        }
        this.loseConfienceRelatedData = Array.from(tableData)
        this.headersRelated = headers
      }
    },
    async _getSassTableData() {
      const params = {
        id: this.$route.query.id,
      }
      const { data } = await getSassTableData(params)
      this.creditList = data
      this.initBase(this.creditList)
      this.initData()
      this.initRelatedData()
      this.initGuaranteeData()
    },
    initData() {
      if (this.creditResult && this.creditResult.mainDiscredit) {
        let {
          defaultLoanList,
          defaultCreditList,
          executorList,
          discreditExecutorList,
        } = this.creditResult.mainDiscredit

        let tableData = []
        let defaultLoanListArr = Array.from(defaultLoanList)
        let defaultCreditListArr = Array.from(defaultCreditList)
        let executorListArr = Array.from(executorList)
        let discreditExecutorListArr = Array.from(discreditExecutorList)
        tableData = [{}, {}, {}, {}]
        let headers = [
          {
            prop: 'title',
            label: '期限',
          },
        ]
        for (let i = 0; i < defaultLoanListArr.length; i++) {
          {
            headers.push({
              label: `${defaultLoanListArr[i].startDate}~${defaultLoanListArr[i].endDate}`,
              prop:
                'key' +
                defaultLoanListArr[i].startDate.split('.')[0] +
                defaultLoanListArr[i].startDate.split('.')[2], //defaultLoanListArr[i].startDate
            })
          }
          {
            let item1 = defaultLoanListArr[i]
            let { amountOfMoney, numberOfTimes } = item1
            tableData[0].title = '拖欠借款'
            tableData[0][
              'key' +
                item1.startDate.split('.')[0] +
                item1.startDate.split('.')[2]
            ] = `${amountOfMoney ? amountOfMoney : '--'}万/${
              numberOfTimes ? numberOfTimes : '--'
            }次`
          }
          {
            let item2 = defaultCreditListArr[i]
            let { amountOfMoney, numberOfTimes } = item2
            tableData[1].title = '拖欠贷款'
            tableData[1][
              'key' +
                item2.startDate.split('.')[0] +
                item2.startDate.split('.')[2]
            ] = `${amountOfMoney ? amountOfMoney : '--'}/${
              numberOfTimes ? numberOfTimes : '--'
            }`
          }
          {
            let item3 = executorListArr[i]
            let { amountOfMoney, numberOfTimes } = item3
            tableData[2].title = '被执行人'
            tableData[2][
              'key' +
                item3.startDate.split('.')[0] +
                item3.startDate.split('.')[2]
            ] = `${amountOfMoney ? amountOfMoney : '--'}/${
              numberOfTimes ? numberOfTimes : '--'
            }`
          }
          {
            let item4 = discreditExecutorListArr[i]
            let { amountOfMoney, numberOfTimes } = item4
            tableData[3].title = '失信被执行人（次）'
            tableData[3][
              'key' +
                item4.startDate.split('.')[0] +
                item4.startDate.split('.')[2]
            ] = `${amountOfMoney ? amountOfMoney : '--'}/${
              numberOfTimes ? numberOfTimes : '--'
            }`
          }
        }
        this.loseConfienceMainData = Array.from(tableData)
        this.headersMain = headers
      }
    },
    initBase(creditList) {
      if (creditList) {
        const {
          gradeResult,
          creditQuota,
          financeResult,
          judicialResult,
          creditResult,
          date,
          gradeMessage,
          warnMessage,
        } = creditList
        this.gradeResult = gradeResult
        this.creditQuota = creditQuota
        this.financeResult = financeResult
        this.judicialResult = judicialResult
        this.creditResult = creditResult
        this.warnMessage = warnMessage
        this.gradeMessage = gradeMessage
        this.date = date && date.substring(0, 10)
        if (this.gradeResult && this.gradeResult.score == null) {
          this.gradeSuccess = false
        } else {
          this.gradeSuccess = true
        }
      }
    },
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this._getSassTableData()
  },
}
</script>
<style scoped lang="less">
.floatR {
  float: right;
  margin-top: -10px;
}
h1 {
  line-height: 44px;
  font-weight: bold;
  height: 44px;
  background: #f5f5fa;
  color: #1677ff;
  font-size: 16px;
  text-indent: 1em;
  margin: 20px 0;
}
.law-data {
  display: flex;
  li {
    flex: 1;
    overflow: hidden;
    p {
      float: left;
      text-align: center;
    }
    dl {
      dt {
        height: 62px;
        line-height: 62px;
        text-align: center;
        span {
          font-size: 30px;
        }
      }
      dd {
        height: 38px;
        line-height: 38px;
        text-align: center;
      }
    }
  }
}
.law-case {
  display: flex;
  justify-content: space-between;

  p {
    margin: 35px 0 13px;
    color: #999;
  }
  .item {
    flex-basis: 48%;
  }
}
.title {
  margin: 35px 0 13px;
  color: #999;
  font-size: 14px;
}
.back {
  margin: 20px 0;
  text-align: center;
}
.indent2 {
  text-indent: 2em;
}
/deep/.ant-descriptions-title {
  color: #1677ff;
  height: 44px;
  background: #f5f5fa;
  line-height: 44px;
  margin: 20px 0;
  text-indent: 1em;
  font-size: 16px;
  font-weight: bold;
}
/deep/ .ant-descriptions-row th {
  width: 200px;
  color: #909399;
  font-weight: 700;
  text-indent: 2em;
}
</style>
